module.exports = __webpack_public_path__ + "img/cases_banner.be90c83a.jpg";